import { render, staticRenderFns } from "./EvolutionScoreView.vue?vue&type=template&id=0c545fd2&scoped=true"
import script from "./EvolutionScoreView.vue?vue&type=script&lang=js"
export * from "./EvolutionScoreView.vue?vue&type=script&lang=js"
import style0 from "./EvolutionScoreView.vue?vue&type=style&index=0&id=0c545fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c545fd2",
  null
  
)

export default component.exports